export default __webpack_public_path__ + "static/media/v-bar-multi.d4feaf6c.svg";